import { isMenuOpen } from '../stores/stores';
export const setMenuOpen = function (menuOpen, mobile, clicked) {
    var _a, _b, _c;
    let menuCurrentState = menuOpen;
    if (clicked && mobile) {
        isMenuOpen.set(!menuOpen);
        menuCurrentState = !menuOpen;
    }
    if (menuOpen == false && !mobile) {
        isMenuOpen.set(menuOpen);
    }
    const mainContentContainer = document.querySelector('.main-content-container');
    const footerContainer = document.querySelector('footer.footer');
    if (menuCurrentState && mobile) {
        setTimeout(() => {
            var _a, _b, _c;
            mainContentContainer === null || mainContentContainer === void 0 ? void 0 : mainContentContainer.classList.add('d-none');
            footerContainer === null || footerContainer === void 0 ? void 0 : footerContainer.classList.add('d-none');
            (_a = document.querySelector('.navbar.header')) === null || _a === void 0 ? void 0 : _a.classList.remove('position-static');
            (_b = document.querySelector('.navbar.header')) === null || _b === void 0 ? void 0 : _b.classList.add('position-fixed');
            (_c = document.querySelector('.navbar.header')) === null || _c === void 0 ? void 0 : _c.classList.add('w-100');
        }, 500); // wait for 500 milliseconds
    }
    else {
        footerContainer === null || footerContainer === void 0 ? void 0 : footerContainer.classList.remove('d-none');
        mainContentContainer === null || mainContentContainer === void 0 ? void 0 : mainContentContainer.classList.remove('d-none');
        (_a = document.querySelector('.navbar.header')) === null || _a === void 0 ? void 0 : _a.classList.remove('position-fixed');
        (_b = document.querySelector('.navbar.header')) === null || _b === void 0 ? void 0 : _b.classList.remove('w-100');
        (_c = document.querySelector('.navbar.header')) === null || _c === void 0 ? void 0 : _c.classList.add('position-static');
    }
};
